import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { Installation } from '../../../../models/configurators-2d/applications/fence/installations/installation';
import { FenceService } from '../../../../services/configurators-2d/applications/fence.service';
import { from, Observable, tap } from 'rxjs';
import { Configuration } from '../../../../models/configurators-2d/applications/fence/configuration';

@Injectable({
  providedIn: 'root',
})
export class InstallationStateService {
  /**
   * Liste des poses
   */
  installations: WritableSignal<Installation[]> = signal([]);

  /**
   * Indique si le service est entrain de faire des changements
   */
  loading: WritableSignal<boolean> = signal(false);

  private readonly fenceService = inject(FenceService);

  /**
   * Requête l'API et défini les poses disponibles
   */
  setList(): Observable<Installation[]> {
    this.loading.set(true);

    return from(this.fenceService.getInstallations()).pipe(
      tap((res: Installation[]) => {
        this.installations.set(res);
        this.loading.set(false);
      })
    );
  }

  /**
   * Récupère une pose par son id
   * @param id
   */
  getById(id: number): Installation | undefined {
    return this.installations().find(i => i.id === id);
  }
}
